import React, { Component } from "react"

// type Props = {
//   link: string;
//   text: string;
//   uuid?: string;
// }

class ProductLink extends Component {
  checkLinkValidity(link) {
    const isValidLink = link.startsWith("http")

    if (!isValidLink) {
      throw new Error(
        "ProductLink was passed a link that didn't begin with `http`! Offending Link:" +
          link
      )
    }
  }

  componentDidMount() {
    this.checkLinkValidity(this.props.href)
  }

  handleOnClick(e) {
    window.analytics.track("Referral Clicked", {
      href: this.props.href,
    })
  }

  render() {
    return (
      <a
        target="_blank"
        className={this.props.className}
        href={this.props.href}
        onClick={this.handleOnClick.bind(this)}
      >
        {this.props.children}
      </a>
    )
  }
}

export default ProductLink
